//  const selectElement = document.querySelector("variant-selects");
// if(selectElement && selectElement.length){
//   selectElement[0]?.addEventListener("click", (event) => {
     
//     var oldVariant = document.getElementsByClassName("axt-cp-custom")[0].getAttribute("axt-cp-variant-id");
//     setTimeout(() => {
//         var variantId = document.querySelector('[name="id"]').value;
//         document.getElementsByClassName("axt-cp-custom")[0].classList.add(variantId);
//         document.getElementsByClassName("axt-cp-custom")[0].classList.remove(oldVariant);
       
//         document.getElementsByClassName("axt-cp-custom")[0].setAttribute("axt-cp-variant-id", variantId);
//     }, "700");
//   });
// }
 
document.addEventListener('change', function (event) {
  const variantSelects = event.target.closest('variant-selects');
  if (!variantSelects) return;

  var oldVariant = document.getElementsByClassName("axt-cp-custom")[0].getAttribute("axt-cp-variant-id");
  

  setTimeout(() => {
      var variantId = document.querySelector('[name="id"]').value;
      document.getElementsByClassName("axt-cp-custom")[0].classList.add(variantId);
      //console.log("newVariant-->", variantId);

      document.getElementsByClassName("axt-cp-custom")[0].classList.remove(oldVariant);

      document.getElementsByClassName("axt-cp-custom")[0].setAttribute("axt-cp-variant-id", variantId);
  }, "1000");
});